<template>
  <div class="nl-placeholder-container">
    Disponible à partir du {{date}}
  </div>
</template>

<script>
  export default {
    name: "NewsletterPlaceholder",
    props: ["date"]
  }
</script>

<style scoped>
  .nl-placeholder-container {
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 24px 36px;
    width: 90%;
    margin-top: 6px;
    margin-bottom: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Adherent/Newsletter/Placeholder.vue